<template>
	<div id="sidebar" class="app-sidebar">
		<div class="app-sidebar-content" data-scrollbar="true" data-height="100%">
			<div class="menu">
				<div class="menu-header">UZWEB</div>
				<div class="menu-item" :class="{active:selMenu=='M'}">
					<a href="/" class="menu-link">
						<span class="menu-icon"><i class="fa-solid fa-chalkboard fa-fw"></i></span>
						<span class="menu-text">Dashboard</span>
					</a>
				</div>
				<div class="menu-item">
					<a href="/connection" class="menu-link">
						<span class="menu-icon"><i class="bi bi-bar-chart"></i></span>
						<span class="menu-text">Connection</span>
					</a>
				</div>					
				<div class="menu-header">TEXT DATA</div>
				<div class="menu-item has-sub" :class="{active:selMenu=='SRC0101'||selMenu=='SRC0102'||selMenu=='SRC0103'||selMenu=='SRC0104'||selMenu=='SRC0105'||selMenu=='SRC0106'||selMenu=='SRC0107'||selMenu=='SRC0108'||selMenu=='SRC0109'||selMenu=='SRC0110'||selMenu=='SRC0111'||selMenu=='SRC0112'||selMenu=='SRC0113'||selMenu=='SRC0114'||selMenu=='SRC0115'||selMenu=='SRC0116'||selMenu=='SRC0117'||selMenu=='SRC0118'||selMenu=='SRC0119'||selMenu=='SRC0120'||selMenu=='SRC0121'||selMenu=='SRC0122'||selMenu=='SRC0123'||selMenu=='SRC0124'}">
					<a href="#" class="menu-link">
						<span class="menu-icon"><i class="fa-solid fa-database fa-fw"></i></span>
						<span class="menu-text">WAMIS</span> 
						<span class="menu-caret"><b class="caret"></b></span>
					</a>
					<div class="menu-submenu">
						<div class="menu-item" :class="{active:selMenu=='SRC0101'}">
							<a href="/detail/SRC_01_01" class="menu-link">
								<span class="menu-text">강수량 관측소</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0102'}">
							<a href="/detail/SRC_01_02" class="menu-link">
								<span class="menu-text">강수량 시자료</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0103'}">
							<a href="/detail/SRC_01_03" class="menu-link">
								<span class="menu-text">강수량 일자료</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0104'}">
							<a href="/detail/SRC_01_04" class="menu-link">
								<span class="menu-text">강수량 월자료</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0105'}">
							<a href="/detail/SRC_01_05" class="menu-link">
								<span class="menu-text">수위 관측소</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0106'}">
							<a href="/detail/SRC_01_06" class="menu-link">
								<span class="menu-text">수위 시자료</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0107'}">
							<a href="/detail/SRC_01_07" class="menu-link">
								<span class="menu-text">수위 일자료</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0108'}">
							<a href="/detail/SRC_01_08" class="menu-link">
								<span class="menu-text">기상 관측소</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0109'}">
							<a href="/detail/SRC_01_09" class="menu-link">
								<span class="menu-text">기상 시자료</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0110'}">
							<a href="/detail/SRC_01_10" class="menu-link">
								<span class="menu-text">기상 일자료</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0111'}">
							<a href="/detail/SRC_01_11" class="menu-link">
								<span class="menu-text">유량 관측소</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0112'}">
							<a href="/detail/SRC_01_12" class="menu-link">
								<span class="menu-text">실시간 일유량</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0113'}">
							<a href="/detail/SRC_01_13" class="menu-link">
								<span class="menu-text">이수시설</span>
							</a>
						</div>
						<!-- <div class="menu-item" :class="{active:selMenu=='SRC0114'}">
							<a href="/view/detail/SRC_01_14.html" class="menu-link">
								<span class="menu-text">양수장시설제원</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0115'}">
							<a href="/view/detail/SRC_01_15.html" class="menu-link">
								<span class="menu-text">양배수장시설제원</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0116'}">
							<a href="/view/detail/SRC_01_16.html" class="menu-link">
								<span class="menu-text">보시설제원</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0117'}">
							<a href="/view/detail/SRC_01_17.html" class="menu-link">
								<span class="menu-text">집수암거시설제원</span>
							</a>
						</div>							
						<div class="menu-item" :class="{active:selMenu=='SRC0118'}">
							<a href="/view/detail/SRC_01_18.html" class="menu-link">
								<span class="menu-text">관정시설제원</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0119'}">
							<a href="/view/detail/SRC_01_19.html" class="menu-link">
								<span class="menu-text">중계펌프장</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0120'}">
							<a href="/view/detail/SRC_01_20.html" class="menu-link">
								<span class="menu-text">기타시설제원</span>
							</a>
						</div> -->
						<div class="menu-item" :class="{active:selMenu=='SRC0121'}">
							<a href="/detail/SRC_01_21" class="menu-link">
								<span class="menu-text">댐</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0122'}">
							<a href="/detail/SRC_01_22" class="menu-link">
								<span class="menu-text">댐수문정보 시자료</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0123'}">
							<a href="/detail/SRC_01_23" class="menu-link">
								<span class="menu-text">댐수문정보 일자료</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0124'}">
							<a href="/detail/SRC_01_24" class="menu-link">
								<span class="menu-text">댐수문정보 월자료</span>
							</a>
						</div>
					</div>
				</div>
				<div class="menu-item has-sub" :class="{active:selMenu=='SRC0201'||selMenu=='SRC0202'||selMenu=='SRC0601'||selMenu=='SRC0603'||selMenu=='SRC0602'||selMenu=='SRC0207'}">
					<a href="#" class="menu-link">
						<span class="menu-icon"><i class="fa-solid fa-database fa-fw"></i></span>
						<span class="menu-text">기상청api허브</span> 
						<span class="menu-caret"><b class="caret"></b></span>
					</a>
					<div class="menu-submenu">
						<div class="menu-item" :class="{active:selMenu=='SRC0201'}">
							<a href="/detail/SRC_02_01" class="menu-link">
								<span class="menu-text">방재기상관측(AWS) 1분</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0202'}">
							<a href="/detail/SRC_02_02" class="menu-link">
								<span class="menu-text">방재기상관측(AWS) 1시간</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0601'}">
							<a href="/detail/SRC_06_01" class="menu-link">
								<span class="menu-text">방재기상관측(AWS) 1일</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0603'}">
							<a href="/detail/SRC_06_03" class="menu-link">
								<span class="menu-text">종관기상관측(ASOS) 1시간</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0602'}">
							<a href="/detail/SRC_06_02" class="menu-link">
								<span class="menu-text">종관기상관측(ASOS) 1일</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0207'}">
							<a href="/detail/SRC_02_07" class="menu-link">
								<span class="menu-text">황사(PM10_KMA)</span>
							</a>
						</div>						
					</div>
				</div>
				<div class="menu-item has-sub" :class="{active:selMenu=='SRC0701'||selMenu=='SRC0702'||selMenu=='SRC0703'||selMenu=='SRC0704'||selMenu=='SRC0705'}">
					<a href="#" class="menu-link">
						<span class="menu-icon"><i class="fa-solid fa-database fa-fw"></i></span>
						<span class="menu-text">도림천 유역</span> 
						<span class="menu-caret"><b class="caret"></b></span>
					</a>
					<div class="menu-submenu">
						<div class="menu-item" :class="{active:selMenu=='SRC0701'}">
							<a href="/detail/SRC_07_01" class="menu-link">
								<span class="menu-text">저류조 10m</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0702'}">
							<a href="/detail/SRC_07_02" class="menu-link">
								<span class="menu-text">펌프장 10m</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0703'}">
							<a href="/detail/SRC_07_03" class="menu-link">
								<span class="menu-text">강수량 10m</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0704'}">
							<a href="/detail/SRC_07_04" class="menu-link">
								<span class="menu-text">하수관로 10m</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0705'}">
							<a href="/detail/SRC_07_05" class="menu-link">
								<span class="menu-text">수위 10m</span>
							</a>
						</div>
					</div>
				</div>
				<div class="menu-item has-sub" :class="{active:selMenu=='SRC0301'||selMenu=='SRC0302'||selMenu=='SRC0303'||selMenu=='SRC0304'||selMenu=='SRC0305'||selMenu=='SRC0306'||selMenu=='SRC0307'}">
					<a href="#" class="menu-link">
						<span class="menu-icon"><i class="fa-solid fa-database fa-fw"></i></span>
						<span class="menu-text">공공데이터포털</span>
						<span class="menu-caret"><b class="caret"></b></span>
					</a>
					<div class="menu-submenu">
						<div class="menu-item" :class="{active:selMenu=='SRC0301'}">
							<a href="/detail/SRC_03_01" class="menu-link">
								<span class="menu-text">농업기상 관측지점 상세정보</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0302'}">
							<a href="/detail/SRC_03_02" class="menu-link">
								<span class="menu-text">농업기상 관측데이터 조회</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0303'}">
							<a href="/detail/SRC_03_03" class="menu-link">
								<span class="menu-text">농촌용수 저수지 측정소</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0304'}">
							<a href="/detail/SRC_03_04" class="menu-link">
								<span class="menu-text">농촌용수 저수지 수위정보</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0305'}">
							<a href="/detail/SRC_03_05" class="menu-link">
								<span class="menu-text">다목적댐 가뭄정보</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0306'}">
							<a href="/detail/SRC_03_06" class="menu-link">
								<span class="menu-text">가뭄 댐 운영정보</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0307'}">
							<a href="/detail/SRC_03_07" class="menu-link">
								<span class="menu-text">산불발생통계</span>
							</a>
						</div>
					</div>
				</div>
				<div class="menu-item has-sub" :class="{active:selMenu=='SRC0401'||selMenu=='SRC0402'||selMenu=='SRC0403'||selMenu=='SRC0404'||selMenu=='SRC0405'}">
					<a href="#" class="menu-link">
						<span class="menu-icon"><i class="fa-solid fa-database fa-fw"></i></span>
						<span class="menu-text">한국수자원공사</span>
						<span class="menu-caret"><b class="caret"></b></span>
					</a>
					<div class="menu-submenu">
						<div class="menu-item" :class="{active:selMenu=='SRC0401'}">
							<a href="/detail/SRC_04_01" class="menu-link">
								<span class="menu-text">토양수분량</span>
							</a>
						</div>
					</div>
				</div>
				<div class="menu-item has-sub" :class="{active:selMenu=='SRC0801'||selMenu=='SRC0802'}">
					<a href="#" class="menu-link">
						<span class="menu-icon"><i class="fa-solid fa-database fa-fw"></i></span>
						<span class="menu-text">통계청</span>
						<span class="menu-caret"><b class="caret"></b></span>
					</a>
					<div class="menu-submenu">
						<div class="menu-item" :class="{active:selMenu=='SRC0801'}">
							<a href="/detail/SRC_08_01" class="menu-link">
								<span class="menu-text">가구</span>
							</a>
						</div>
						<div class="menu-item" :class="{active:selMenu=='SRC0802'}">
							<a href="/detail/SRC_08_02" class="menu-link">
								<span class="menu-text">인구</span>
							</a>
						</div>
					</div>
				</div>
				<div class="menu-item has-sub" :class="{active:selMenu=='SRC0501'||selMenu=='SRC0502'||selMenu=='SRC0503'||selMenu=='SRC0504'||selMenu=='SRC0505'}">
					<a href="#" class="menu-link">
						<span class="menu-icon"><i class="fa-solid fa-database fa-fw"></i></span>
						<span class="menu-text">Open-Meteo</span>
						<span class="menu-caret"><b class="caret"></b></span>
					</a>
					<div class="menu-submenu">
						<div class="menu-item" :class="{active:selMenu=='SRC0501'}">
							<a href="/detail/SRC_05_01" class="menu-link">
								<span class="menu-text">ECMWF</span>
							</a>
						</div>							
					</div>
				</div>
				<div class="menu-item has-sub" :class="{active:selMenu=='SRC0901'}">
					<a href="#" class="menu-link">
						<span class="menu-icon"><i class="fa-solid fa-database fa-fw"></i></span>
						<span class="menu-text">나라장터</span>
						<span class="menu-caret"><b class="caret"></b></span>
					</a>
					<div class="menu-submenu">
						<div class="menu-item" :class="{active:selMenu=='SRC0901'}">
							<a href="/detail/SRC_09_01" class="menu-link">
								<span class="menu-text">입찰공고</span>
							</a>
						</div>							
					</div>
				</div>
				<div class="menu-header">MAP DATA</div>
				<div class="menu-item" :class="{active:selMenu=='SRC10'}">
					<a href="/detail/SRC_10" class="menu-link">
						<span class="menu-icon"><i class="far fa-sm fa-fw me-2 fa-map"></i></span>
						<span class="menu-text">침수</span>
					</a>
				</div>
				<div class="menu-divider"></div>
				<div class="menu-header">Users</div>
				<div class="menu-item">
					<a href="profile.html" class="menu-link">
						<span class="menu-icon"><i class="bi bi-people"></i></span>
						<span class="menu-text">Profile</span>
					</a>
				</div>
				<div class="menu-item">
					<a href="calendar.html" class="menu-link">
						<span class="menu-icon"><i class="bi bi-calendar4"></i></span>
						<span class="menu-text">Calendar</span>
					</a>
				</div>
				<div class="menu-item">
					<a href="settings.html" class="menu-link">
						<span class="menu-icon"><i class="bi bi-gear"></i></span>
						<span class="menu-text">Settings</span>
					</a>
				</div>
				<div class="menu-item">
					<a href="helper.html" class="menu-link">
						<span class="menu-icon"><i class="bi bi-gem"></i></span>
						<span class="menu-text">Helper</span>
					</a>
				</div>
			</div>
			<div class="p-3 px-4 mt-auto">
				<a href="../../documentation/index.html" class="btn d-block btn-outline-theme">
					<i class="fa fa-code-branch me-2 ms-n2 opacity-5"></i> Documentation
				</a>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    name: 'global-menu',
    data () {
      return {
        selMenu: "M",
      }
    }
    , mounted: function () {
        console.log("globalMenu");
				pageLoad(this);
      try {
        
      } catch (e) {
        console.log(e);
      }
    },
    methods: {
      showTitle () {
        this.title = 'Global Component!!'
      }
			,fnGetInit: function(paramMenu){
				console.log(paramMenu);
				let vm = this;
				vm.selMenu = paramMenu;
			}
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/menu.vue